import { FirebaseErrorCode} from '@modeso/aumico-lib-users-fe';
import { FirebaseError } from '@angular/fire/app';
import { localizationKeys } from '../../utils/localizationKeys';


const getFirebaseErrorMessage = (error: FirebaseError) : string =>{
  if (error.code === FirebaseErrorCode.WRONG_PASSWORD || error.code === FirebaseErrorCode.USER_NOT_FOUND) {
      return localizationKeys.aumico_reports_login_credentials_error;
  } else if (error.code === FirebaseErrorCode.INTERNAL_ERROR) {
      return localizationKeys.aumico_errors_server_error;
  } else if (error.code === FirebaseErrorCode.TOO_MANY_REQUESTS) {
      return localizationKeys.aumico_reports_login_credentials_toomany_requests_error;
  }
  else if( error.code === FirebaseErrorCode.NETWORK_REQUEST_FAILED){
      return localizationKeys.aumico_reports_login_credentials_network_request_failed;
  }

  return error.message;
}


export default getFirebaseErrorMessage;
